import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useStyleContext, useStyleLoading } from "../../../customHooks/useStyleContext";

const DEFAULT_PRIMARY_COLOR = "#7165e3";

/**
 * ThemeWrapper creates the MUI theme dynamically after styles are loaded.
 * Place this inside a StyleProvider.
 */
const ThemeWrapper = ({ children, themeOverrides = {} }) => {
    const styles = useStyleContext();
    const isLoading = useStyleLoading();

    let primaryColor = styles?.colors?.["c-main"];
    if (!primaryColor) {
        primaryColor = DEFAULT_PRIMARY_COLOR;
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: primaryColor,
            }
        },
        ...themeOverrides,
    });

    if (isLoading) {
        return (
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <div>Loading...</div>
                </div>
            </ThemeProvider>
        );
    }

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default ThemeWrapper;
